const menuBoard = () => import(/* webpackChunkName: "dinein setting" */ '@/components/settings/menuBoard')

export default {
    name: 'menuBoard',
    path: 'Visuals/menuBoard',
    redirect: '/Visuals/menuBoard/index',
    meta: {label: 'settings'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7]},
            component: menuBoard,
            props: true
        }
    ]
}
